import { BusinessUserType } from '__generated__/api-types-and-hooks'

export const JOB_TITLES = [
  { label: 'Associate / Analyst', value: 'Associate / Analyst' },
  { label: 'CEO', value: 'CEO' },
  { label: 'Co-Founder', value: 'Co-Founder' },
  { label: 'Consultant', value: 'Consultant' },
  { label: 'COO', value: 'COO' },
  { label: 'Designer', value: 'Designer' },
  { label: 'Executive Assistant/Admin', value: 'Executive Assistant/Admin' },
  { label: 'Intern', value: 'Intern' },
  { label: '(Senior) Finance Manager', value: '(Senior) Finance Manager' },
  { label: '(Senior) Marketing Manager', value: '(Senior) Marketing Manager' },
  {
    label: '(Senior) Sales/ Business Development Manager',
    value: '(Senior) Sales/ Business Development Manager',
  },
  { label: '(Senior) Sales Rep', value: '(Senior) Sales Rep' },
  { label: 'Director', value: 'Director' },
  { label: 'Other', value: 'Other' },
]

export const ACCOUNT_TYPES_LABELS = [
  { label: 'Basic', value: 'Basic' },
  { label: 'Admin', value: 'Admin' },
  { label: 'Co-owner', value: 'Co-owner' },
  { label: 'Owner', value: 'Owner' },
]

export const EDUCATION_TYPES = [
  { label: 'Some High School', value: 'Some High School' },
  { label: 'High School Dliploma/GED', value: 'High School Dliploma/GED' },
  { label: 'Some College', value: 'Some College' },
  { label: 'Asssociate’s Degree', value: 'Asssociate’s Degree' },
  { label: 'Bachelor’s Degree', value: 'Bachelor’s Degree' },
  { label: 'Master’s Degree', value: 'Master’s Degree' },
  { label: 'PhD/Doctorate Degree', value: 'PhD/Doctorate Degree' },
]

export const WORK_LOCATION_TYPES = [
  { label: 'In-person', value: 'In-person' },
  { label: 'Hybrid', value: 'Hybrid' },
  { label: 'Remote', value: 'Remote' },
]

export const EMPLOYMENT_TYPES = [
  { label: 'Full-time Employee', value: 'Full-time Employee' },
  { label: 'Part-time Employee', value: 'Part-time Employee' },
  { label: 'Full-time Contractor', value: 'Full-time Contractor' },
  { label: 'Part-time Contractor', value: 'Part-time Contractor' },
  { label: 'Intern', value: 'Intern' },
  { label: 'Other', value: 'Other' },
]

export const AREA_OF_EXPERTISE = [
  { label: 'Sales', value: 'Sales' },
  { label: 'Marketing', value: 'Marketing' },
  { label: 'Finance', value: 'Finance' },
  { label: 'Human Resources', value: 'Human Resources' },
  { label: 'Operations', value: 'Operations' },
  { label: 'Production', value: 'Production' },
  { label: 'Research & Development', value: 'Research & Development' },
  { label: 'Information Technology', value: 'Information Technology' },
  { label: 'Legal', value: 'Legal' },
  { label: 'Customer Service', value: 'Customer Service' },
  { label: 'Communications', value: 'Communications' },
  { label: 'Strategy', value: 'Strategy' },
  { label: 'Other', value: 'Other' },
]

export const ACCOUNT_TYPES_VALUES = {
  Basic: BusinessUserType.Member,
  Admin: BusinessUserType.Admin,
  'Co-owner': BusinessUserType.CoOwner,
  Owner: BusinessUserType.Owner,
}

export const YEARS_OF_WORK_EXPERIENCE = [
  { label: '0-2 years', value: '0-2 years' },
  { label: '3-5 years', value: '3-5 years' },
  { label: '6-10 years', value: '6-10 years' },
  { label: '11-15 years', value: '11-15 years' },
  { label: '16+ years', value: '16+ years' },
]
